'use client'
import { createContext, useContext } from 'react'

export type SheetSurfacePosition = 'mobile-sheet' | 'desktop-launcher'

// Which nav surface the shared rows are rendering on. Rows stamp it as
// data-event-position, so the two surfaces split apart in analytics while
// every event name stays the same.
export const SheetSurfaceContext = createContext<SheetSurfacePosition>('mobile-sheet')

export const useSheetSurface = () => useContext(SheetSurfaceContext)
